const SMS_NOTIFICATION_STATUS = {
    NOT_AVAILABLE: 0,
    AVAILABLE: 1,
    AVAILABLE_BUT_ENROLLED: 2
};

export { SMS_NOTIFICATION_STATUS };
